import(/* webpackMode: "eager" */ "D:\\jc-gardening\\src\\app\\globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\jc-gardening\\src\\components\\layout\\Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\jc-gardening\\src\\components\\ui\\BackToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\jc-gardening\\src\\components\\ui\\FloatingContactButtons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\jc-gardening\\src\\components\\ViewportHeightSetter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "D:\\jc-gardening\\src\\contexts\\LanguageContext.tsx");
